import React from "react";
import { ReactElement } from "react";
import { Link } from "react-router-dom";

// Image
import AuthIcon from "pages/common/auth-icon";
import logoLight from "assets/images/iclicks-high-resolution-logo-white-transparent.png";
import logoDark from "assets/images/iclicks-high-resolution-logo-transparent.png";

interface Props {
  children: ReactElement;
}
const BasicLayout: React.FC<Props> = (props: Props) => {
  React.useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <div className="relative">
        <AuthIcon />

        <div className="mb-0 w-screen lg:mx-auto lg:w-[500px] card shadow-lg border-none shadow-slate-100 relative">
          <div className="!px-10 !py-12 card-body">
            <Link to="/">
              <img src={logoLight} alt="" className="hidden h-[100px] mx-auto dark:block" />
              <img src={logoDark} alt="" className="block h-[100px] mx-auto dark:hidden" />
            </Link>
            {props.children}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicLayout;
